module.exports = __webpack_public_path__ + "images/stickers/pete-busy@2x.7f431e9ee1ad9fabaafc.png";